import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { serviceProvider } from './serviceProvider';

export const venue: SchemaWithClient<any> = {
  name: 'Address',
  pluralName: 'Address',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    service_provider: {
      name: 'Service Provider',
      fieldRenderer: SelectField.tableAdapter(serviceProvider),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(serviceProvider),
      switchboard: true,
      accordingTo: 'activity',
      required: true,
    },
    type: {
      name: 'Type',
      fieldRenderer: SelectField.tableAdapter(enumItems.addressType),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.addressType),
      switchboard: true,
      url: enumItems.addressType.client.getAllPath,
      tempSchema: enumItems.addressType,
    },
    address_line1: {
      name: 'Address Line 1',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    coordinates: {
      name: 'Coordinates',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/addresses'),
};
